import React from "react";
import { descripcionRegistro } from "../../../../helpers/tiposCierreMensual";

// Aviso de si el período se puede cerrar con el tipo elegido. Cuando no se
// puede, el detalle del backend es el que explica qué falta; en el completo
// además nombra la mitad que lo impide. La captura y la acción van al pie de la
// pantalla
export const CierreMensualSeccion = ({ cierreMensual }) => {
    const { estadoPeriodo, tipo, puedeCerrar } = cierreMensual;

    if (!estadoPeriodo) {
        return null;
    }

    const periodo = estadoPeriodo.periodo;

    const descripcion = descripcionRegistro(tipo);

    return (
        <div
            className={`alert bold text-white ${
                puedeCerrar ? "alert-success" : "alert-warning"
            }`}
        >
            <strong>
                {descripcion.charAt(0).toUpperCase() + descripcion.slice(1)}
            </strong>

            {periodo && <span className="ml-2">Período {periodo.periodo}</span>}

            {estadoPeriodo.detalle && (
                <div className="mt-1">{estadoPeriodo.detalle}</div>
            )}
        </div>
    );
};
